module.exports = __webpack_public_path__ + "img/user_icon.92b24c1.svg";